class MobileMegaMenu extends HTMLElement {
  connectedCallback() {
    this.overlay = document.querySelector("[data-mobile-mega-overlay]");
    this.closeBtn = this.querySelector("[data-mobile-mega-close]");
    this.titleEl = this.querySelector("[data-mobile-mega-title]");
    this.rootTitle = this.titleEl?.textContent || "";
    this.panelHistory = ["root"];
    this.querySelectorAll("[data-drill]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const target = btn.dataset.drill;
        this.drillTo(target);
      });
    });
    this.querySelectorAll("[data-back]").forEach((btn) => {
      btn.addEventListener("click", () => {
        this.drillBack();
      });
    });
    this.closeBtn?.addEventListener("click", () => this.close());
    this.overlay?.addEventListener("click", () => this.close());
    this.querySelectorAll("[data-mobile-mega-link]").forEach((link) => {
      link.addEventListener("click", () => this.close());
    });
    this.renderNavLinks();
    document.addEventListener("click", (e) => {
      const trigger = e.target.closest('[href="#mobile-mega-menu"]');
      if (trigger) {
        e.preventDefault();
        this.open();
      }
    });
  }
  open() {
    const stickyHeader = document.querySelector("sticky-header");
    if (stickyHeader) {
      stickyHeader.preventHide = true;
      stickyHeader.reveal();
    }
    this.classList.remove("-translate-x-full");
    this.classList.add("translate-x-0");
    document.body.classList.add("overflow-hidden");
    if (this.overlay) {
      this.overlay.classList.remove("pointer-events-none", "opacity-0");
      this.overlay.classList.add("pointer-events-auto", "opacity-100");
    }
  }
  close() {
    this.classList.remove("translate-x-0");
    this.classList.add("-translate-x-full");
    document.body.classList.remove("overflow-hidden");
    const stickyHeader = document.querySelector("sticky-header");
    if (stickyHeader) {
      stickyHeader.preventHide = false;
    }
    if (this.overlay) {
      this.overlay.classList.remove("pointer-events-auto", "opacity-100");
      this.overlay.classList.add("pointer-events-none", "opacity-0");
    }
    setTimeout(() => this.resetToRoot(), 300);
  }
  drillTo(panelId) {
    const currentId = this.panelHistory[this.panelHistory.length - 1];
    const currentPanel = this.querySelector(`[data-panel="${currentId}"]`);
    const nextPanel = this.querySelector(`[data-panel="${panelId}"]`);
    if (!currentPanel || !nextPanel) return;
    currentPanel.classList.remove("translate-x-0");
    currentPanel.classList.add("-translate-x-full");
    nextPanel.classList.remove("translate-x-full");
    nextPanel.classList.add("translate-x-0");
    this.panelHistory.push(panelId);
  }
  drillBack() {
    if (this.panelHistory.length <= 1) return;
    const currentId = this.panelHistory.pop();
    const previousId = this.panelHistory[this.panelHistory.length - 1];
    const currentPanel = this.querySelector(`[data-panel="${currentId}"]`);
    const previousPanel = this.querySelector(`[data-panel="${previousId}"]`);
    if (!currentPanel || !previousPanel) return;
    currentPanel.classList.remove("translate-x-0");
    currentPanel.classList.add("translate-x-full");
    previousPanel.classList.remove("-translate-x-full");
    previousPanel.classList.add("translate-x-0");
  }
  renderNavLinks() {
    const items = window.__headerNavLinks;
    if (!items || !items.length) return;
    const wrapper = this.querySelector("[data-mobile-nav-links]");
    const list = this.querySelector("[data-mobile-nav-links-list]");
    if (!wrapper || !list) return;
    items.forEach((item) => {
      const li = document.createElement("li");
      const a = document.createElement("a");
      a.href = item.link;
      a.className = "flex w-full items-center gap-3 rounded-xl px-4 py-3 transition-colors hover:bg-gray-50";
      a.setAttribute("data-mobile-mega-link", "");
      a.addEventListener("click", () => this.close());
      if (item.icon) {
        const img = document.createElement("img");
        img.src = item.icon;
        img.className = "h-6 w-6 shrink-0 object-contain";
        img.alt = item.text;
        img.loading = "lazy";
        a.appendChild(img);
      }
      const span = document.createElement("span");
      span.className = "text-base font-medium";
      span.textContent = item.text;
      a.appendChild(span);
      li.appendChild(a);
      list.appendChild(li);
    });
    wrapper.classList.remove("hidden");
  }
  resetToRoot() {
    this.querySelectorAll(".mobile-mega-panel").forEach((panel) => {
      if (panel.dataset.panel === "root") {
        panel.classList.remove("-translate-x-full", "translate-x-full");
        panel.classList.add("translate-x-0");
      } else {
        panel.classList.remove("translate-x-0", "-translate-x-full");
        panel.classList.add("translate-x-full");
      }
    });
    this.panelHistory = ["root"];
  }
}
window.customElements.define("mobile-mega-menu", MobileMegaMenu);
